<template>
  <div class="min-h-screen bg-white">
    <!-- <Header /> -->
    <div v-if="userInfo?.user" class="sticky top-0 z-50 bg-white shadow-md">
      <AdminHeader v-if="userInfo?.user?.permission === 'super_admin'" />
      <HodHeader v-if="userInfo?.user?.permission === 'hod'" />
      <CoordinateHeader v-if="userInfo?.user?.permission === 'co-ordinator'" />
      <InstructorHeader v-if="userInfo?.user?.permission === 'instructor'" />
    </div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="py-5">
      <div
        class="container mx-auto px-5 xl:px-0 max-w-[1200px] flex flex-col gap-5"
      >
        <div class="flex justify-end">
          <button
            @click="$router.go(-1)"
            class="inline-flex items-center gap-2 bg-blues hover:bg-hover text-white text-xs font-semibold px-5 py-1.5 rounded-xl shadow transition"
          >
            Back
          </button>
        </div>
        <div class="bg-white rounded-xl shadow-sm border border-slate-200 p-3">
          <div
            class="flex flex-col lg:flex-row lg:items-center justify-between gap-4"
          >
            <div
              class="flex-shrink-0 min-w-max border-b lg:border-b-0 pb-2 lg:pb-0 border-slate-100"
            >
              <h1 class="text-lg font-semibold">Download</h1>
              <p class="text-sm text-slate-500 mt-1">
                Total Activities
                <span class="text-blue-600"> ({{ totalcount || 0 }}) </span>
              </p>
            </div>

            <div
              class="flex flex-wrap md:flex-nowrap items-center gap-2 w-full lg:justify-end"
            >
              <div class="flex-1 md:flex-none w-full md:max-w-40">
                <select
                  v-model="selected_ordering"
                  @change="getdownload(1)"
                  class="w-full px-4 py-2 rounded-xl text-xs border border-slate-200 bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                >
                  <option value="" disabled>Sort By</option>
                  <option value="user__email">A → Z</option>
                  <option value="-user__email">Z → A</option>
                  <option value="-created_at">Newest</option>
                  <option value="-download_count">Most Downloads</option>
                </select>
              </div>

              <div class="flex-1 md:flex-none md:w-36">
                <select
                  v-model="selected_filter"
                  @change="getdownload(1)"
                  class="w-full px-4 py-2 rounded-xl text-xs border border-slate-200 bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                >
                  <option value="" disabled>File Type</option>
                  <option
                    v-for="filetype in filetype_list"
                    :key="filetype.file_type"
                    :value="filetype.file_type"
                  >
                    {{ filetype.file_type.toUpperCase() }}
                  </option>
                </select>
              </div>

              <div
                class="relative w-full md:max-w-80 order-first md:order-none"
              >
                <div
                  class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
                <input
                  type="text"
                  v-model="searching"
                  @input="getdownload(1)"
                  placeholder="Search..."
                  class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-xs text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                />
                <button
                  v-if="searching"
                  @click="clearSearch"
                  class="absolute inset-y-0 right-0 pr-3 flex items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 text-gray-400 hover:text-gray-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              <button
                @click="clearFilters"
                class="flex-none bg-slate-100 hover:bg-red-50 hover:text-red-600 text-slate-500 text-[11px] font-bold px-4 py-1.5 rounded-xl transition-all border border-transparent hover:border-red-100"
              >
                Clear
              </button>
            </div>
          </div>
        </div>

        <div v-if="this.history_list.length > 0">
          <div
            class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-x-auto"
          >
            <table class="w-full text-sm">
              <thead class="bg-gray-100 text-textblues">
                <tr>
                  <th class="border-b border-r px-4 py-3 text-left">S.No</th>
                  <th class="border-b border-r px-4 py-3 text-left">User</th>
                  <th class="border-b border-r px-4 py-3 text-left">Title</th>
                  <th class="border-b border-r px-4 py-3 text-left">
                    File Type
                  </th>
                  <th class="border-b border-r px-4 py-3 text-left">
                    Created At
                  </th>
                  <th class="border-b border-r px-4 py-3 text-left">
                    Downloads
                  </th>
                  <th class="border-b border-r px-4 py-3 text-left">Status</th>
                  <th class="border-b border-r px-4 py-3 text-center">
                    Action
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(el, index) in history_list"
                  :key="index"
                  class="table-row text-[13px]"
                >
                  <td
                    class="px-4 py-3 border-b border-r text-xs text-slate-400 font-medium"
                  >
                    {{ (currentPage - 1) * pageSize + index + 1 }}
                  </td>

                  <td class="px-4 py-3 border-b border-r">
                    <div class="flex items-center gap-3">
                      <div
                        class="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 text-[10px] font-black shadow-sm border border-blue-200 uppercase"
                      >
                        <span v-if="el?.user?.display_name">
                          {{ el?.user?.display_name?.charAt(0) }}
                        </span>
                        <span v-else>{{ el?.user?.email?.charAt(0) }}</span>
                      </div>
                      <div class="flex flex-col min-w-0">
                        <span
                          class="text-xs font-bold text-slate-800 truncate leading-tight uppercase"
                        >
                          {{ el?.user?.display_name }}
                        </span>
                        <span class="text-[10px] text-slate-400 truncate">
                          {{ el?.user?.email }}
                        </span>
                      </div>
                    </div>
                  </td>

                  <td
                    class="px-4 py-3 border-b border-r text-xs font-medium text-slate-600 max-w-[200px] truncate"
                  >
                    {{ el.course_id?.course_title || "OverAll List" }}
                  </td>

                  <td
                    class="px-4 py-3 border-b border-r text-xs font-medium text-slate-600"
                  >
                    {{ el.file_type || "NA" }}
                  </td>

                  <td
                    class="px-4 py-3 border-b border-r text-xs font-medium text-slate-600"
                  >
                    {{ el.created_at ? formatDate(el.created_at) : "NA" }}
                  </td>

                  <td
                    class="px-4 py-3 border-b border-r text-xs font-medium text-slate-600 text-center"
                  >
                    {{ el.download_count || 0 }}
                  </td>

                  <td class="px-4 py-3 border-b border-r text-xs">
                    <span
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                      :class="{
                        'bg-emerald-100 text-emerald-800':
                          el.status === 'Completed' || el.status === 'Success',
                        'bg-amber-100 text-amber-800':
                          el.status === 'Processing' || el.status === 'Pending',
                        'bg-red-100 text-red-800': el.status === 'Failed',
                        'bg-gray-100 text-gray-600':
                          !el.status || el.status === 'NA',
                      }"
                    >
                      <span
                        class="w-1.5 h-1.5 rounded-full mr-1.5"
                        :class="{
                          'bg-emerald-500':
                            el.status === 'Completed' ||
                            el.status === 'Success',
                          'bg-amber-500 animate-pulse':
                            el.status === 'Processing' ||
                            el.status === 'Pending',
                          'bg-red-500': el.status === 'Failed',
                          'bg-gray-400': !el.status || el.status === 'NA',
                        }"
                      ></span>
                      {{ el.status || "NA" }}
                    </span>
                  </td>

                  <td class="table-cell text-center">
                    <a
                      v-if="el.media_path"
                      :href="el.media_path"
                      target="_blank"
                      @click="triggerdownload(el.id)"
                      :title="el.course_id?.course_title || 'OverAll List'"
                      class="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-blue-50 text-blue-600 hover:bg-blue-100 transition-all duration-200 group"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4 hover:scale-110 transition cursor-pointer"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                        />
                      </svg>
                    </a>
                    <div
                      v-else-if="el.status === 'Failed'"
                      class="text-red-500 mx-auto"
                    >
                      -
                    </div>
                    <div v-else class="spinner mx-auto"></div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- <Pagination
            :totalPages="totalPages"
            ref="paginationRef"
            @page-changed="this.getdownload"
          /> -->
          <div
            class="flex flex-col sm:flex-row justify-center gap-3 mt-4 relative"
          >
            <!-- PAGE SIZE -->
            <div
              class="md:absolute md:left-3 md:top-4 gap-2 text-sm text-gray-600 flex justify-center items-center md:flex-none md:justify-normal"
            >
              <span class="flex md:hidden">Rows per page:</span>
              <select
                v-model="pageSize"
                @change="onPageSizeChange"
                class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option :value="10">10</option>
                <option :value="20">20</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
            </div>

            <!-- PAGINATION -->
            <div v-if="totalPages > 1" class="flex justify-center">
              <Pagination
                :totalPages="totalPages"
                ref="paginationRef"
                @page-changed="getdownload"
              />
            </div>
          </div>
        </div>
        <div v-else class="flex justify-center">No Data Found</div>
      </div>
    </div>
  </div>
</template>

<script>
import InstructorHeader from "@/components/Instructor/Header.vue";
import AdminHeader from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import FlashMessage from "@/components/FlashMessage.vue";
import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    InstructorHeader,
    AdminHeader,
    HodHeader,
    CoordinateHeader,
    FlashMessage,
    Pagination,
  },

  data() {
    return {
      messages: {
        text: "",
        type: "null",
      },
      disable_submit: false,
      history_list: [],
      totalPages: 1,
      currentPage: 1,
      pageSize: 10,
      totalcount: "",
      searching: "",
      filetype_list: [],
      selected_filter: "",
      selected_ordering: "",
    };
  },

  computed: mapGetters(["userInfo"]),

  async created() {
    this.getdownload(1);
    this.getfiletype();
  },
  methods: {
    clearSearch() {
      this.searching = "";
      this.getdownload(1);
    },
    onPageSizeChange() {
      this.currentPage = 1;
      if (this.$refs.paginationRef) {
        this.$refs.paginationRef.currentPage = 1;
      }
      this.getdownload(1);
    },
    formatDate(date) {
      const d = new Date(date);
      return d.toLocaleString();
    },
    async getdownload(page) {
      this.currentPage = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/staff-download-history/list/?Key=${this.userInfo.token_key}&page=${page}&search=${this.searching}&file_type=${this.selected_filter}&ordering=${this.selected_ordering}&page_size=${this.pageSize}`,
        )
        .then((resp) => {
          if (resp.data.data.status == 200) {
            this.totalcount = resp.data.total;
            this.history_list = resp.data.data.data;
            this.totalPages = resp.data.total_page;
            this.current_page = resp.data.current_page;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    async triggerdownload(id) {
      await axios
        .put(
          `${process.env.VUE_APP_API}/download-history/update/${id}/?Key=${this.userInfo.token_key}`,
          [],
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.getdownload(1);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    async getfiletype() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/download-history-file-type/get/?Key=${this.userInfo.token_key}`,
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.filetype_list = resp.data.data;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    clearFilters() {
      this.selected_filter = "";
      this.selected_ordering = "";
      this.searching = "";
      this.getdownload(this.current_page);
    },
  },
};
</script>

<style scoped>
.filter-input {
  @apply w-full rounded-xl border border-slate-300 bg-white px-4 py-2.5 text-sm text-slate-700 focus:ring-2 focus:ring-blue-500 outline-none;
}
.table-head {
  @apply px-6 py-4 text-left text-xs font-bold uppercase tracking-wider;
}

.table-row {
  @apply border-b hover:bg-slate-50 transition;
}

.table-cell {
  @apply px-6 py-4 whitespace-nowrap;
}

.status-pill {
  @apply px-3 py-1 rounded-full text-xs font-semibold;
}

.status-active {
  @apply bg-green-100 text-green-700;
}

.status-na {
  @apply bg-slate-200 text-slate-600;
}

.spinner {
  width: 18px;
  height: 18px;
  border: 3px solid #e5e7eb;
  border-top: 3px solid #2563eb;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
